var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLottery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 75,
    viewBox: "0 0 142 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_4202)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    clipPath: "url(#clip1_883_4202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.458 122.073L76.8457 10.1621L30.4969 36.9216L95.1087 148.833L141.458 122.073Z",
    fill: "url(#paint0_linear_883_4202)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2273 144.456L34.7692 38.0078L75.6499 14.4053L137.108 120.854L96.2273 144.456ZM36.503 38.6055L96.7304 142.922L135.528 120.523L75.3006 16.2057L36.503 38.6055Z",
    fill: "#8C6E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6473 71.6052L100.073 73.8462L103.18 74.7171L99.6473 71.6052Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6473 71.6051L103.18 74.717L102.032 71.827L99.6473 71.6051Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6477 71.6051L95.0083 71.0862L97.6948 72.7326L99.6477 71.6051Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6475 71.6055L97.6946 72.733L97.7772 75.8827L99.6475 71.6055Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6475 71.6055L97.7772 75.8827L100.073 73.8465L99.6475 71.6055Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.843 69.9825L95.0083 71.0862L99.6477 71.6051L97.843 69.9825Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6476 71.6056L102.032 71.8274L103.684 69.2754L99.6476 71.6056Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6477 71.6049L98.6421 66.8564L97.843 69.9824L99.6477 71.6049Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.683 69.2752L100.648 69.4292L99.6475 71.6054L103.683 69.2752Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6473 71.6049L100.648 69.4286L98.6416 66.8564L99.6473 71.6049Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5828 63.2059L93.9614 64.7636L96.1094 65.4775L93.5828 63.2059Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5828 63.2058L96.1095 65.4774L95.3463 63.2535L93.5828 63.2058Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5827 63.205L90.1624 62.6929L92.1506 64.0319L93.5827 63.205Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.583 63.2061L92.1509 64.0329L92.2395 66.291L93.583 63.2061Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.583 63.2061L92.2395 66.291L93.9616 64.7638L93.583 63.2061Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.346 61.965L90.1624 62.6929L93.5827 63.205L92.346 61.965Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5832 63.2054L95.3466 63.2531L96.5776 61.4766L93.7134 63.1302L93.5832 63.2054Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5831 63.2062L92.8022 59.749L92.3464 61.9662L93.5831 63.2062Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5775 61.4765L94.3465 61.5211L93.7132 63.1302L96.5775 61.4765Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5832 63.2061L93.7133 63.1309L94.3467 61.5218L92.8023 59.7489L93.5832 63.2061Z",
    fill: "#FFCB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3076 59.9854L75.1082 61.3719L71.8499 64.1775C71.1169 64.7856 70.5195 65.3154 69.7865 65.9234C70.6796 65.5927 71.4372 65.3402 72.3302 65.0095L76.5492 63.8678L77.1896 64.9771L74.0914 68.06C73.3585 68.668 72.761 69.1978 72.1081 69.9446C73.0012 69.6138 73.7588 69.3613 74.6518 69.0306L78.7106 67.6116L79.271 68.5822L71.1534 71.4202L70.1927 69.7563L73.4264 66.5952C73.8883 66.1436 74.3503 65.692 74.8923 65.379C74.2702 65.5533 73.6482 65.7276 73.1062 66.0405L68.7517 67.2604L67.7911 65.5965L74.3076 59.9854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9116 69.6914L80.6321 70.9393L73.315 75.1639L72.5945 73.9159L79.9116 69.6914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7524 72.8809L82.553 74.2675L79.8489 78.9716L78.7586 80.5255C79.4361 80.1343 80.3046 79.448 81.1176 78.9786L84.2342 77.1793L84.9546 78.4272L77.6375 82.6518L76.837 81.2652L79.5411 76.561L80.6314 75.0072C79.8183 75.4766 79.0854 76.0846 78.2724 76.554L75.1558 78.3533L74.4353 77.1054L81.7524 72.8809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6563 58.1838L52.9702 31.0146L51.774 31.7053L67.4601 58.8745L68.6563 58.1838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4505 57.1474L59.2959 37.8271L58.6978 38.1725L69.8523 57.4928L70.4505 57.1474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2635 59.5644L55.1089 40.2441L54.5108 40.5895L65.6653 59.9098L66.2635 59.5644Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_883_4202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142 95.3749L50.625 4L12.7813 41.8437L104.156 133.219L142 95.3749Z",
    fill: "url(#paint1_linear_883_4202)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.104 128.702L17.1894 41.7872L50.5684 8.4082L137.483 95.3231L104.104 128.702ZM19.0188 41.9158L104.193 127.09L135.871 95.4121L50.697 10.2376L19.0188 41.9158Z",
    fill: "#8C6E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5522 57.4478L89.5436 59.5022L92.7699 59.5394L88.5522 57.4478Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5526 57.4474L92.7703 59.539L90.9136 57.0444L88.5526 57.4474Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5528 57.4473L83.9372 58.1468L86.9582 59.0418L88.5528 57.4473Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5522 57.4473L86.9577 59.0418L87.8527 62.0629L88.5522 57.4473Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5522 57.4473L87.8527 62.0629L89.5437 59.5017L88.5522 57.4473Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3896 56.3471L83.9372 58.1468L88.5528 57.4473L86.3896 56.3471Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5523 57.4477L90.9132 57.0448L91.8477 54.1523L88.5523 57.4477Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5524 57.4475L86.3521 53.1211L86.3892 56.3473L88.5524 57.4475Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8477 54.1519L88.9552 55.0863L88.5523 57.4473L91.8477 54.1519Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5524 57.4471L88.9553 55.0861L86.352 53.1207L88.5524 57.4471Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0967 65.4795L95.9744 66.9949L98.234 67.1285L95.0967 65.4795Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0966 65.479L98.2339 67.1281L96.9211 65.1775L95.0966 65.479Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0967 65.4796L91.7692 65.9789L93.9274 66.6489L95.0967 65.4796Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0967 65.4795L93.9274 66.6488L94.5974 68.8071L95.0967 65.4795Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0967 65.4795L94.5974 68.8071L95.9743 66.995L95.0967 65.4795Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5813 64.6019L91.7692 65.9789L95.0967 65.4796L93.5813 64.6019Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.097 65.4791L96.9215 65.1776L97.542 63.0342L95.2033 65.3728L95.097 65.4791Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0969 65.4797L93.5566 62.4512L93.5814 64.602L95.0969 65.4797Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5417 63.0339L95.3983 63.6544L95.2031 65.3726L97.5417 63.0339Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0968 65.4792L95.2031 65.3729L95.3984 63.6548L93.5566 62.4507L95.0968 65.4792Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5205 50.9033L81.2894 52.31L83.549 52.4436L80.5205 50.9033Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5205 50.9038L83.549 52.4441L82.2362 50.4935L80.5205 50.9038Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.52 50.9038L77.0836 51.2943L79.3507 52.0731L80.52 50.9038Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5205 50.9033L79.3512 52.0726L80.0212 54.2309L80.5205 50.9033Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5205 50.9033L80.0212 54.2309L81.2894 52.31L80.5205 50.9033Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0045 50.0261L77.0836 51.2943L80.52 50.9038L79.0045 50.0261Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5204 50.9039L82.2361 50.4936L82.9653 48.459L80.6267 50.7976L80.5204 50.9039Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5201 50.9039L78.8711 47.7666L79.0046 50.0262L80.5201 50.9039Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9651 48.4587L80.8217 49.0792L80.6264 50.7974L82.9651 48.4587Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5206 50.9034L80.6269 50.7971L80.8221 49.079L78.8715 47.7662L80.5206 50.9034Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0688 52.7832L62.201 53.9154L59.7799 57.4686C59.2293 58.2457 58.7893 58.9121 58.2387 59.6891C59.0157 59.1385 59.6821 58.6985 60.4592 58.1479L64.2389 55.9532L65.1446 56.8589L62.9499 60.6386C62.3993 61.4157 61.9593 62.0821 61.5219 62.9723C62.299 62.4217 62.9654 61.9818 63.7424 61.4311L67.2957 59.01L68.0882 59.8025L60.9816 64.6448L59.6231 63.2862L61.9284 59.3959C62.2577 58.8401 62.587 58.2843 63.0296 57.8418C62.4738 58.1711 61.9181 58.5005 61.4755 58.943L57.5852 61.2483L56.2266 59.8897L61.0688 52.7832Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9937 60.708L70.0126 61.7269L64.0382 67.7013L63.0193 66.6824L68.9937 60.708Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5977 63.3125L72.7298 64.4446L71.3354 69.6884L70.6844 71.4715C71.2376 70.9183 71.8989 70.0306 72.5627 69.3668L75.1073 66.8222L76.1263 67.8411L70.1519 73.8155L69.0197 72.6833L70.4142 67.4396L71.0651 65.6565C70.4013 66.3203 69.8507 67.0974 69.1868 67.7612L66.6422 70.3058L65.6233 69.2869L71.5977 63.3125Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7114 69.4258L78.8436 70.5579L77.4491 75.8017L76.7982 77.5848C77.3514 77.0316 78.0126 76.1439 78.6764 75.4801L81.2211 72.9354L82.24 73.9544L76.2656 79.9288L75.1335 78.7966L76.5279 73.5529L77.1789 71.7698C76.515 72.4336 75.9644 73.2106 75.3006 73.8745L72.756 76.4191L71.737 75.4002L77.7114 69.4258Z",
    fill: "#1F2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.144 52.5048L32.9604 30.3213L31.9837 31.298L54.1673 53.4816L55.144 52.5048Z",
    fill: "#8C6E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6089 51.0396L40.834 35.2646L40.3456 35.753L56.1206 51.528L56.6089 51.0396Z",
    fill: "#8C6E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1905 54.4586L37.4155 38.6836L36.9272 39.172L52.7021 54.9469L53.1905 54.4586Z",
    fill: "#8C6E20"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_883_4202",
    x1: 109.152,
    y1: 66.1176,
    x2: 62.8028,
    y2: 92.8771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_883_4202",
    x1: 96.3124,
    y1: 49.6874,
    x2: 58.4688,
    y2: 87.5311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_4202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 86,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_883_4202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.224,
    height: 53.2097,
    fill: "white",
    transform: "translate(76.8457 10.1621) rotate(60)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_883_4202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.224,
    height: 53.2097,
    fill: "white",
    transform: "translate(50.625 4) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLottery);
export default __webpack_public_path__ + "static/media/lottery.2ac132246432dc68377d9a029473c727.svg";
export { ForwardRef as ReactComponent };